
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-8c47ae10!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./JsonColumnComponent.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./JsonColumnComponent.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-8c47ae10!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./JsonColumnComponent.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/grid/JsonColumnComponent.vue
// module id = 226
// module chunks = 2